import { IProjectDetail, pimImageToOpenGraphImage } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { getPageProps } from '@viabizzuno/ui/server';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getPage, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';
import { BreadcrumbStructuredData } from '@viabizzuno/ui';
import { GetStaticPropsResult } from 'next';

export default function ProjectDetail({ layout, page, params }: PageProps<IProjectDetail>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <BreadcrumbStructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.pimJson?.immagine_copertina ? pimImageToOpenGraphImage(page.pimJson.immagine_copertina) : undefined,
      })} />
    </>
  );
}

ProjectDetail.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext): Promise<GetStaticPropsResult<PageProps<IProjectDetail>>> {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<IProjectDetail>('project_detail', id, market, locale, context);
  /*
  const items = await getHomepages({ market, locale });
  console.log(items.length);
  */
  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const components = page.components || [];
  components.push({
    schema: 'block_anchors',
  });
  components.push({
    schema: 'block_project_intro',
  });
  components.push({
    schema: 'block_project_description',
    project: { ...page },
  });
  components.push({
    schema: 'block_designers_proposition',
  });
  components.push({
    schema: 'block_project_products',
  });
  components.push({
    schema: 'block_full_image',
    ...(page.pimJson?.foto_progetto_full ? { media: { item: page.pimJson.foto_progetto_full } } : undefined),
  });
  components.push({
    schema: 'block_project_relateds',
  });
  components.push({
    schema: 'block_banner_segment',
    segment: page.segment,
  });
  page.components = components;

  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    /*
    * Next.js will attempt to re-generate the page when a request comes in at most once every 60 seconds
    */
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('project_detail');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
